import React, { useState, useEffect } from "react";
import PageHeader from "../../../components/styled/PageHeader";
import { TabItem, Typography } from "@plum-xoxo/admin-dsm";
import Tab from "../../../components/styled/Tab";
import TableComponent from "./TableComponent";
import ProformaInvoice from "../../../components/Modals/ProformaInvoice";
import { getEnabledModules } from "../utils/getEnabledModules";
import { getContentWrapperClass } from "../../../utils/header";

const Reports = ({
  title = "Reports",
  accountReducer,
  plumPro,
  history,
  initialData,
  initialFetchParams,
  type = "",
  fetchAdminList,
}) => {
  let initialActiveTab = 0;
  if (history?.location?.title) {
    initialActiveTab = initialData.findIndex(
      (data) =>
        data?.title?.toLowerCase() === history?.location?.title?.toLowerCase()
    );
    if (initialActiveTab === -1) {
      initialActiveTab = 0;
    }
  }
  const [activeTab, setActiveTab] = useState(initialActiveTab || 0);
  const [showProformsSuccess, setShowProformsSuccess] = useState(false);
  const [employeeEmail, setEmployeeEmail] = useState("");

  useEffect(() => {
    const response = history.location.state
      ? JSON.parse(history.location.state)
      : "";
    setShowProformsSuccess(response?.showProformsSuccess);
    setEmployeeEmail(response?.employee_email);
    window.history.replaceState({}, document.title);
  }, []);

  const { enabledModules } = getEnabledModules(accountReducer);
  const visibleModulesList = enabledModules.filter((module) => module.enable);
  let showBackButton = true;
  if (visibleModulesList.length === 1) {
    showBackButton = false;
  }
  return (
    <div
      className={`${getContentWrapperClass({
        accountReducer,
      })}`}
    >
      <PageHeader
        title={title}
        subtitle="View and download reports of all transactions made within the organization."
        className="mt-0 mb-8"
        showBackButton={showBackButton}
      />
      {showProformsSuccess ? (
        <ProformaInvoice
          headerTitle=""
          headerClass="d-none"
          proformaBody={
            <div className="text-left">
              <img src="/admin/img/svg-icons/icon-success-large.svg" />
              <Typography.H2 color="dark" shade="c300" className="my-12">
                Invoice generated successfully
              </Typography.H2>
              <Typography color="dark" shade="c200">
                Your invoice has been generated and sent to {employeeEmail}.
              </Typography>
            </div>
          }
          modalStatus={() => {
            setShowProformsSuccess(false);
          }}
          disableCross={false}
          topMargin="mt-48"
          buttonText="OK, Got It"
          actionProformaHandler={() => {
            setShowProformsSuccess(false);
          }}
          className="actionModalFooterRight pb-0"
        />
      ) : null}
      <Tab
        activeTab={activeTab}
        onChange={(e, index) => {
          setActiveTab(index);
        }}
      >
        {initialData.map((tab) => (
          <TabItem
            title={
              <span
                id={`reports-tab-${tab?.title
                  ?.replace(" ", "-")
                  ?.toLowerCase()}`}
              >
                {tab.title}
              </span>
            }
            active={activeTab}
            key={tab.title}
          >
            <TableComponent
              tableData={initialData[activeTab]}
              activeTab={activeTab}
              initialFetchParams={initialFetchParams}
              accountReducer={accountReducer}
              plumPro={plumPro}
              type={type}
              history={history}
            />
          </TabItem>
        ))}
      </Tab>
    </div>
  );
};

export default Reports;
